import { createGlobalStyle } from 'styled-components'

const GlobalStyle = createGlobalStyle`
    .sentry-error-embed-wrapper {
        z-index: 2000 !important;
}
`

export default GlobalStyle
